import React, { useState } from 'react';
import { Button, Input, Modal, message, theme } from 'antd';
import { BugOutlined, CopyOutlined } from '@ant-design/icons';
import AppTheme from './theme/AppTheme';
import siteConfig from '../siteConfig';
import companyLogo from '../assets/images/uzd_logo_small.jpeg';

function AboutContent({ open, onClose }) {
  const { token } = theme.useToken();
  const [reporting, setReporting] = useState(false);
  const [description, setDescription] = useState('');
  const [feedback, contextHolder] = message.useMessage();
  const copyReport = async () => {
    try {
      await navigator.clipboard.writeText(`${siteConfig.name} Web\nVersion: ${siteConfig.version}\nBuild: ${siteConfig.build_no}\n\n${description.trim()}`);
      feedback.success('Bug report copied. Share it with your administrator.');
    } catch {
      feedback.error('Could not copy the report. Please copy your description manually.');
    }
  };
  return <Modal open={open} onCancel={onClose} title={`About ${siteConfig.name} Web`} centered width={440}
    styles={{ body: { maxHeight: 'calc(100dvh - 190px)', overflowY: 'auto' } }}
    style={{ maxWidth: 'calc(100vw - 48px)' }}
    footer={<><Button icon={<BugOutlined />} onClick={() => setReporting(value => !value)}>Report a bug</Button><Button onClick={onClose}>Close</Button></>}>
    {contextHolder}
    <div style={{ textAlign: 'center', margin: '12px 0 20px' }}>
      <img src={companyLogo} alt="Uzdpart company logo" style={{ width: 120, maxWidth: '100%', height: 'auto', borderRadius: 8 }} />
    </div>
    <p>{siteConfig.description}</p>
    <dl style={{ display: 'grid', gridTemplateColumns: '80px 1fr', gap: '8px 12px', margin: '20px 0' }}>
      <dt style={{ color: token.colorTextSecondary }}>Version</dt><dd style={{ margin: 0 }}>{siteConfig.version}</dd>
      <dt style={{ color: token.colorTextSecondary }}>Build</dt><dd style={{ margin: 0 }}>{siteConfig.build_no}</dd>
    </dl>
    {reporting && <div style={{ marginBottom: 20 }}>
      <p style={{ color: token.colorTextSecondary }}>Describe the issue and the steps to reproduce it. For now, copy this report and share it with your administrator. Nothing is submitted automatically.</p>
      <Input.TextArea aria-label="Bug description" placeholder="What happened? What did you expect?" rows={4} value={description} onChange={event => setDescription(event.target.value)} />
      <Button style={{ marginTop: 10 }} icon={<CopyOutlined />} disabled={!description.trim()} onClick={copyReport}>Copy bug report</Button>
    </div>}
    <div style={{ borderTop: `1px solid ${token.colorBorderSecondary}`, paddingTop: 14, color: token.colorTextSecondary, fontSize: 12, textAlign: 'center' }}>
      Made with ❤️ in UAE, Uzdpart Spare Parts Trading LLC© {new Date().getFullYear()}
    </div>
  </Modal>;
}

export default function AboutModal(props) {
  return <AppTheme><AboutContent {...props} /></AppTheme>;
}
